import {
  Component,
  OnInit,
  AfterViewInit,
  OnDestroy,
  ViewChild,
  ElementRef,
  HostListener,
} from '@angular/core';
import { CompanyProfileService } from './services/company-profile.service';
import { environment } from 'src/environments/environment';
import { ProfileForm } from './interfaces/company-profile';
import Quill from 'quill';
import { TranslateService } from '@ngx-translate/core';
import { Router } from '@angular/router';
import { DomSanitizer, SafeResourceUrl } from '@angular/platform-browser';

type ValidatableField =
  | 'fullName'
  | 'email'
  | 'phone'
  | 'website'
  | 'facebook'
  | 'youtube'
  | 'snapchat'
  | 'twitter'
  | 'linkedin'
  | 'instagram';

@Component({
  selector: 'app-company-profile-admin',
  templateUrl: './company-profile-admin.component.html',
  styleUrls: ['./company-profile-admin.component.css'],
})
export class CompanyProfileAdminComponent
  implements OnInit, AfterViewInit, OnDestroy
{
  @ViewChild('quillEditor') quillEditorRef!: ElementRef;
  private quillInstance!: Quill;

  @ViewChild('quillBenefits') quillBenefitsRef!: ElementRef;
  private quillBenefitsInstance!: Quill;
  @ViewChild('quillVision') quillVisionRef!: ElementRef;
  private quillVisionInstance!: Quill;
  @ViewChild('countryTrigger') countryTrigger!: ElementRef;

  countries: any[] = [
    // Arab Countries
    {
      name: 'Algeria',
      code: 'dz',
      dial: '+213',
      flag: 'https://flagcdn.com/w20/dz.png',
    },
    {
      name: 'Bahrain',
      code: 'bh',
      dial: '+973',
      flag: 'https://flagcdn.com/w20/bh.png',
    },
    {
      name: 'Comoros',
      code: 'km',
      dial: '+269',
      flag: 'https://flagcdn.com/w20/km.png',
    },
    {
      name: 'Djibouti',
      code: 'dj',
      dial: '+253',
      flag: 'https://flagcdn.com/w20/dj.png',
    },
    {
      name: 'Egypt',
      code: 'eg',
      dial: '+20',
      flag: 'https://flagcdn.com/w20/eg.png',
    },
    {
      name: 'Iraq',
      code: 'iq',
      dial: '+964',
      flag: 'https://flagcdn.com/w20/iq.png',
    },
    {
      name: 'Jordan',
      code: 'jo',
      dial: '+962',
      flag: 'https://flagcdn.com/w20/jo.png',
    },
    {
      name: 'Kuwait',
      code: 'kw',
      dial: '+965',
      flag: 'https://flagcdn.com/w20/kw.png',
    },
    {
      name: 'Lebanon',
      code: 'lb',
      dial: '+961',
      flag: 'https://flagcdn.com/w20/lb.png',
    },
    {
      name: 'Libya',
      code: 'ly',
      dial: '+218',
      flag: 'https://flagcdn.com/w20/ly.png',
    },
    {
      name: 'Mauritania',
      code: 'mr',
      dial: '+222',
      flag: 'https://flagcdn.com/w20/mr.png',
    },
    {
      name: 'Morocco',
      code: 'ma',
      dial: '+212',
      flag: 'https://flagcdn.com/w20/ma.png',
    },
    {
      name: 'Oman',
      code: 'om',
      dial: '+968',
      flag: 'https://flagcdn.com/w20/om.png',
    },
    {
      name: 'Palestine',
      code: 'ps',
      dial: '+970',
      flag: 'https://flagcdn.com/w20/ps.png',
    },
    {
      name: 'Qatar',
      code: 'qa',
      dial: '+974',
      flag: 'https://flagcdn.com/w20/qa.png',
    },
    {
      name: 'Saudi Arabia',
      code: 'sa',
      dial: '+966',
      flag: 'https://flagcdn.com/w20/sa.png',
    },
    {
      name: 'Somalia',
      code: 'so',
      dial: '+252',
      flag: 'https://flagcdn.com/w20/so.png',
    },
    {
      name: 'Sudan',
      code: 'sd',
      dial: '+249',
      flag: 'https://flagcdn.com/w20/sd.png',
    },
    {
      name: 'Syria',
      code: 'sy',
      dial: '+963',
      flag: 'https://flagcdn.com/w20/sy.png',
    },
    {
      name: 'Tunisia',
      code: 'tn',
      dial: '+216',
      flag: 'https://flagcdn.com/w20/tn.png',
    },
    {
      name: 'United Arab Emirates',
      code: 'ae',
      dial: '+971',
      flag: 'https://flagcdn.com/w20/ae.png',
    },
    {
      name: 'Yemen',
      code: 'ye',
      dial: '+967',
      flag: 'https://flagcdn.com/w20/ye.png',
    },
    // EU Countries
    {
      name: 'Austria',
      code: 'at',
      dial: '+43',
      flag: 'https://flagcdn.com/w20/at.png',
    },
    {
      name: 'Belgium',
      code: 'be',
      dial: '+32',
      flag: 'https://flagcdn.com/w20/be.png',
    },
    {
      name: 'Bulgaria',
      code: 'bg',
      dial: '+359',
      flag: 'https://flagcdn.com/w20/bg.png',
    },
    {
      name: 'Croatia',
      code: 'hr',
      dial: '+385',
      flag: 'https://flagcdn.com/w20/hr.png',
    },
    {
      name: 'Cyprus',
      code: 'cy',
      dial: '+357',
      flag: 'https://flagcdn.com/w20/cy.png',
    },
    {
      name: 'Czech Republic',
      code: 'cz',
      dial: '+420',
      flag: 'https://flagcdn.com/w20/cz.png',
    },
    {
      name: 'Denmark',
      code: 'dk',
      dial: '+45',
      flag: 'https://flagcdn.com/w20/dk.png',
    },
    {
      name: 'Estonia',
      code: 'ee',
      dial: '+372',
      flag: 'https://flagcdn.com/w20/ee.png',
    },
    {
      name: 'Finland',
      code: 'fi',
      dial: '+358',
      flag: 'https://flagcdn.com/w20/fi.png',
    },
    {
      name: 'France',
      code: 'fr',
      dial: '+33',
      flag: 'https://flagcdn.com/w20/fr.png',
    },
    {
      name: 'Germany',
      code: 'de',
      dial: '+49',
      flag: 'https://flagcdn.com/w20/de.png',
    },
    {
      name: 'Greece',
      code: 'gr',
      dial: '+30',
      flag: 'https://flagcdn.com/w20/gr.png',
    },
    {
      name: 'Hungary',
      code: 'hu',
      dial: '+36',
      flag: 'https://flagcdn.com/w20/hu.png',
    },
    {
      name: 'Ireland',
      code: 'ie',
      dial: '+353',
      flag: 'https://flagcdn.com/w20/ie.png',
    },
    {
      name: 'Italy',
      code: 'it',
      dial: '+39',
      flag: 'https://flagcdn.com/w20/it.png',
    },
    {
      name: 'Latvia',
      code: 'lv',
      dial: '+371',
      flag: 'https://flagcdn.com/w20/lv.png',
    },
    {
      name: 'Lithuania',
      code: 'lt',
      dial: '+370',
      flag: 'https://flagcdn.com/w20/lt.png',
    },
    {
      name: 'Luxembourg',
      code: 'lu',
      dial: '+352',
      flag: 'https://flagcdn.com/w20/lu.png',
    },
    {
      name: 'Malta',
      code: 'mt',
      dial: '+356',
      flag: 'https://flagcdn.com/w20/mt.png',
    },
    {
      name: 'Netherlands',
      code: 'nl',
      dial: '+31',
      flag: 'https://flagcdn.com/w20/nl.png',
    },
    {
      name: 'Poland',
      code: 'pl',
      dial: '+48',
      flag: 'https://flagcdn.com/w20/pl.png',
    },
    {
      name: 'Portugal',
      code: 'pt',
      dial: '+351',
      flag: 'https://flagcdn.com/w20/pt.png',
    },
    {
      name: 'Romania',
      code: 'ro',
      dial: '+40',
      flag: 'https://flagcdn.com/w20/ro.png',
    },
    {
      name: 'Slovakia',
      code: 'sk',
      dial: '+421',
      flag: 'https://flagcdn.com/w20/sk.png',
    },
    {
      name: 'Slovenia',
      code: 'si',
      dial: '+386',
      flag: 'https://flagcdn.com/w20/si.png',
    },
    {
      name: 'Spain',
      code: 'es',
      dial: '+34',
      flag: 'https://flagcdn.com/w20/es.png',
    },
    {
      name: 'Sweden',
      code: 'se',
      dial: '+46',
      flag: 'https://flagcdn.com/w20/se.png',
    },
  ];

  selectedCountry = this.countries[0];
  showCountryDropdown = false;
  countrySearch = '';

  logoPreview: string | null = null;
  logoFile: File | null = null;
  // ✅ FIX: track when the user explicitly removed the existing server logo
  logoRemoved = false;

  coverPreviews: string[] = [];
  coverFiles: File[] = [];

  taxDocFile: File | null = null;
  taxDocName: string | null = null;

  commercialDocFile: File | null = null;
  commercialDocName: string | null = null;

  previewUrl: SafeResourceUrl | null = null;
  rawPreviewUrl: string | null = null;
  previewIsImage = false;
  previewFileName: string | null = null;

  isDragging = false;
  isSaving = false;
  saveError: string | null = null;
  saveSuccess = false;

  errors: Partial<Record<ValidatableField, string>> = {};
  touched: Partial<Record<ValidatableField, boolean>> = {};

  private readonly validatableFields: ValidatableField[] = [
    'fullName',
    'email',
    'phone',
    'website',
    'facebook',
    'youtube',
    'snapchat',
    'twitter',
    'linkedin',
    'instagram',
  ];

  profile: ProfileForm = {
    fullName: '',
    phone: '',
    email: '',
    website: '',
    about: '',
    benefits: '',
    vision: '',
    founder: '',
    orgType: '',
    teamSize: '',
    activityType: '',
    foundedIn: '',
    facebook: '',
    youtube: '',
    snapchat: '',
    twitter: '',
    linkedin: '',
    instagram: '',
    taxRegistrationDocument: null,
    commercialRegistrationDocument: null,
  };
  companyId: string = '';

  private originalProfile: ProfileForm = { ...this.profile };
  private originalLogo: string | null = null;
  private originalCovers: string[] = [];
  private originalTaxDocName: string | null = null;
  private originalCommercialDocName: string | null = null;

  constructor(
    private companyProfileService: CompanyProfileService,
    private translate: TranslateService,
    private route: Router,
    private sanitizer: DomSanitizer,
  ) {}

  ngOnInit(): void {
    this.loadProfile();
  }

  ngAfterViewInit(): void {
    this.quillInstance = new Quill(this.quillEditorRef.nativeElement, {
      theme: 'snow',
      placeholder: this.translate.instant(
        'Write something about your company…',
      ),
      modules: {
        toolbar: [
          ['bold', 'italic', 'underline', 'strike'],
          [{ header: [1, 2, false] }],
          [{ font: [] }],
          [{ size: ['small', false, 'large', 'huge'] }],
          ['link'],
          [{ align: [] }],
          [{ list: 'ordered' }, { list: 'bullet' }],
          ['clean'],
        ],
      },
    });

    if (this.profile.about) {
      this.quillInstance.root.innerHTML = this.profile.about;
    }
    this.quillVisionInstance = new Quill(this.quillVisionRef.nativeElement, {
      theme: 'snow',
      placeholder: this.translate.instant("Describe your company's vision…"),
      modules: {
        toolbar: [
          ['bold', 'italic', 'underline', 'strike'],
          [{ header: [1, 2, false] }],
          [{ font: [] }],
          [{ size: ['small', false, 'large', 'huge'] }],
          ['link'],
          [{ align: [] }],
          [{ list: 'ordered' }, { list: 'bullet' }],
          ['clean'],
        ],
      },
    });

    if (this.profile.vision) {
      this.quillVisionInstance.root.innerHTML = this.profile.vision;
    }

    this.quillVisionInstance.on('text-change', () => {
      this.profile.vision = this.quillVisionInstance.root.innerHTML;
    });

    this.quillInstance.on('text-change', () => {
      this.profile.about = this.quillInstance.root.innerHTML;
    });

    this.quillBenefitsInstance = new Quill(
      this.quillBenefitsRef.nativeElement,
      {
        theme: 'snow',
        placeholder: this.translate.instant(
          'Write about your company benefits…',
        ),
        modules: {
          toolbar: [
            ['bold', 'italic', 'underline', 'strike'],
            [{ header: [1, 2, false] }],
            [{ font: [] }],
            [{ size: ['small', false, 'large', 'huge'] }],
            ['link'],
            [{ align: [] }],
            [{ list: 'ordered' }, { list: 'bullet' }],
            ['clean'],
          ],
        },
      },
    );

    if (this.profile.benefits) {
      this.quillBenefitsInstance.root.innerHTML = this.profile.benefits;
    }

    this.quillBenefitsInstance.on('text-change', () => {
      this.profile.benefits = this.quillBenefitsInstance.root.innerHTML;
    });
  }

  ngOnDestroy(): void {}

  private loadProfile(): void {
    this.companyProfileService.getCompanyProfile().subscribe({
      next: (res: any) => {
        this.mapResponseToProfile(res);
        this.snapshotOriginal();
        if (this.quillInstance && this.profile.about) {
          this.quillInstance.root.innerHTML = this.profile.about;
        }
        if (this.quillVisionInstance && this.profile.vision) {
          this.quillVisionInstance.root.innerHTML = this.profile.vision;
        }
        if (this.quillBenefitsInstance && this.profile.benefits) {
          this.quillBenefitsInstance.root.innerHTML = this.profile.benefits;
        }
      },
      error: (err) => console.error('Failed to load profile', err),
    });
  }

  private mapResponseToProfile(res: any): void {
    this.companyId = res.userId ?? '';
    this.profile.fullName = res.name ?? '';
    this.profile.email = res.email ?? '';
    this.profile.website = res.website ?? '';

    let phoneStr = res.phoneNumber ?? '';
    this.selectedCountry = this.countries[0];
    if (phoneStr.startsWith('+')) {
      const match = this.countries.find((c) => phoneStr.startsWith(c.dial));
      if (match) {
        this.selectedCountry = match;
        phoneStr = phoneStr.substring(match.dial.length).trim();
      }
    }
    this.profile.phone = phoneStr;

    this.profile.about = res.aboutCompany ?? '';
    this.profile.benefits = res.benefits ?? '';
    this.profile.vision = res.vision ?? '';
    this.profile.founder = res.founder ?? '';
    this.profile.orgType = res.orgType ?? '';
    this.profile.foundedIn = res.foundedIn ?? null;
    this.profile.activityType = res.industryType ?? '';
    this.profile.instagram = res.instagramLink ?? '';
    this.profile.linkedin = res.linkedinLink ?? '';
    this.profile.twitter = res.twitterLink ?? '';
    this.profile.facebook = res.facebookLink ?? '';
    this.profile.youtube = res.youtubeLink ?? '';
    this.profile.snapchat = res.snapchatLink ?? '';

    if (res.companySizeFrom != null && res.companySizeTo != null) {
      this.profile.teamSize = `${res.companySizeFrom}–${res.companySizeTo}`;
    }

    if (res.logoUrl) this.logoPreview = res.logoUrl;
    if (res.coverUrl) this.coverPreviews = [res.coverUrl];

    this.profile.taxRegistrationDocument = res.taxRegistrationDocument ?? null;
    this.profile.commercialRegistrationDocument =
      res.commercialRegistrationDocument ?? null;

    if (res.taxRegistrationDocument) {
      this.taxDocName =
        res.taxRegistrationDocument.split(/[\\/]/).pop() ?? 'Tax Document';
    }
    if (res.commercialRegistrationDocument) {
      this.commercialDocName =
        res.commercialRegistrationDocument.split(/[\\/]/).pop() ??
        'Commercial Document';
    }
  }

  getImagePath(path: string | null | undefined): string {
    if (!path) return '';
    if (
      path.startsWith('data:') ||
      path.startsWith('http://') ||
      path.startsWith('https://')
    ) {
      return path;
    }
    return environment.apiUrl + path;
  }

  onPhoneKeyDown(event: KeyboardEvent): void {
    const allowedKeys = [
      'Backspace',
      'Delete',
      'Tab',
      'Escape',
      'Enter',
      'ArrowLeft',
      'ArrowRight',
      'ArrowUp',
      'ArrowDown',
      'Home',
      'End',
    ];
    if (
      allowedKeys.includes(event.key) ||
      event.ctrlKey ||
      event.metaKey ||
      /^\d$/.test(event.key) ||
      event.key === '+'
    ) {
      return;
    }
    event.preventDefault();
  }

  onBlur(field: ValidatableField): void {
    this.touched[field] = true;
    this.validateField(field);
  }

  private validateField(field: ValidatableField): void {
    switch (field) {
      case 'fullName':
        if (!this.profile.fullName?.trim()) {
          this.errors.fullName = 'Full name is required.';
        } else {
          delete this.errors.fullName;
        }
        break;

      case 'email':
        if (!this.profile.email?.trim()) {
          this.errors.email = 'Email is required.';
        } else if (!this.isValidEmail(this.profile.email)) {
          this.errors.email = 'Please enter a valid email address.';
        } else {
          delete this.errors.email;
        }
        break;

      case 'phone':
        if (this.profile.phone?.trim()) {
          const phoneRegex = /^(\+?\d{1,4})?\d{7,14}$/;
          if (
            !phoneRegex.test(this.profile.phone.trim().replace(/\s|-/g, ''))
          ) {
            this.errors.phone = 'Enter a valid phone number.';
          } else {
            delete this.errors.phone;
          }
        } else {
          delete this.errors.phone;
        }
        break;

      case 'website':
        if (
          this.profile.website?.trim() &&
          !this.isValidUrl(this.profile.website)
        ) {
          this.errors.website =
            'Please enter a valid URL (e.g. https://example.com).';
        } else {
          delete this.errors.website;
        }
        break;

      case 'facebook':
        if (
          this.profile.facebook?.trim() &&
          !this.isValidUrl(this.profile.facebook)
        ) {
          this.errors.facebook = 'Please enter a valid Facebook URL.';
        } else {
          delete this.errors.facebook;
        }
        break;

      case 'youtube':
        if (
          this.profile.youtube?.trim() &&
          !this.isValidUrl(this.profile.youtube)
        ) {
          this.errors.youtube = 'Please enter a valid YouTube URL.';
        } else {
          delete this.errors.youtube;
        }
        break;

      case 'snapchat':
        if (
          this.profile.snapchat?.trim() &&
          !this.isValidUrl(this.profile.snapchat)
        ) {
          this.errors.snapchat = 'Please enter a valid Snapchat URL.';
        } else {
          delete this.errors.snapchat;
        }
        break;

      case 'twitter':
        if (
          this.profile.twitter?.trim() &&
          !this.isValidUrl(this.profile.twitter)
        ) {
          this.errors.twitter = 'Please enter a valid X (Twitter) URL.';
        } else {
          delete this.errors.twitter;
        }
        break;

      case 'linkedin':
        if (
          this.profile.linkedin?.trim() &&
          !this.isValidUrl(this.profile.linkedin)
        ) {
          this.errors.linkedin = 'Please enter a valid LinkedIn URL.';
        } else {
          delete this.errors.linkedin;
        }
        break;

      case 'instagram':
        if (
          this.profile.instagram?.trim() &&
          !this.isValidUrl(this.profile.instagram)
        ) {
          this.errors.instagram = 'Please enter a valid Instagram URL.';
        } else {
          delete this.errors.instagram;
        }
        break;
    }
  }

  private validateAll(): boolean {
    this.validatableFields.forEach((field) => {
      this.touched[field] = true;
      this.validateField(field);
    });
    return Object.keys(this.errors).length === 0;
  }

  private isValidEmail(email: string): boolean {
    return /^[^\s@]+@[^\s@]+\.[^\s@]+$/.test(email);
  }

  private isValidUrl(url: string): boolean {
    try {
      const u = new URL(url);
      return u.protocol === 'http:' || u.protocol === 'https:';
    } catch {
      return false;
    }
  }

  onLogoChange(event: Event): void {
    const file = (event.target as HTMLInputElement).files?.[0];
    if (!file) return;
    this.logoFile = file;
    // ✅ FIX: user is uploading a new logo, so it's no longer "removed"
    this.logoRemoved = false;
    this.readFile(file, (result) => (this.logoPreview = result));
  }

  removeLogo(): void {
    this.logoPreview = null;
    this.logoFile = null;
    // ✅ FIX: mark that the existing server logo should be deleted on save
    this.logoRemoved = true;
  }

  onCoverChange(event: Event): void {
    const files = Array.from((event.target as HTMLInputElement).files ?? []);
    this.addCoverFiles(files);
  }

  removeCover(index: number): void {
    this.coverPreviews.splice(index, 1);
    this.coverFiles.splice(index, 1);
  }

  onDragOver(event: DragEvent): void {
    event.preventDefault();
    this.isDragging = true;
  }

  onDragLeave(): void {
    this.isDragging = false;
  }

  onDrop(event: DragEvent): void {
    event.preventDefault();
    this.isDragging = false;
    const files = Array.from(event.dataTransfer?.files ?? []).filter((f) =>
      f.type.startsWith('image/'),
    );
    this.addCoverFiles(files);
  }

  onTaxDocChange(event: Event): void {
    const file = (event.target as HTMLInputElement).files?.[0];
    if (!file) return;
    this.taxDocFile = file;
    this.taxDocName = file.name;
  }

  removeTaxDoc(): void {
    this.taxDocFile = null;
    this.taxDocName = null;
    this.profile.taxRegistrationDocument = null;
  }

  onCommercialDocChange(event: Event): void {
    const file = (event.target as HTMLInputElement).files?.[0];
    if (!file) return;
    this.commercialDocFile = file;
    this.commercialDocName = file.name;
  }

  removeCommercialDoc(): void {
    this.commercialDocFile = null;
    this.commercialDocName = null;
    this.profile.commercialRegistrationDocument = null;
  }

  openDocument(path: string | null, fileName: string | null): void {
    if (!path) return;
    this.companyProfileService.getDocument(path).subscribe({
      next: (blob) => {
        const objectUrl = URL.createObjectURL(blob);
        this.rawPreviewUrl = objectUrl;
        if (blob.type.startsWith('image/')) {
          this.previewUrl = this.sanitizer.bypassSecurityTrustResourceUrl(objectUrl);
          this.previewIsImage = true;
          this.previewFileName = fileName;
        } else if (blob.type === 'application/pdf') {
          this.previewUrl = this.sanitizer.bypassSecurityTrustResourceUrl(objectUrl);
          this.previewIsImage = false;
          this.previewFileName = fileName;
        } else {
          window.open(objectUrl, '_blank');
          setTimeout(() => URL.revokeObjectURL(objectUrl), 30_000);
        }
      },
      error: (err) => console.error('Failed to open document', err),
    });
  }

  downloadDocument(path: string | null, fileName: string | null): void {
    if (!path) return;
    this.companyProfileService.getDocument(path).subscribe({
      next: (blob) => {
        const objectUrl = URL.createObjectURL(blob);
        const a = document.createElement('a');
        a.href = objectUrl;
        a.download = fileName ?? 'document';
        a.click();
        setTimeout(() => URL.revokeObjectURL(objectUrl), 5_000);
      },
      error: (err) => console.error('Download failed', err),
    });
  }

  closePreview(): void {
    if (this.rawPreviewUrl) URL.revokeObjectURL(this.rawPreviewUrl);
    this.previewUrl = null;
    this.rawPreviewUrl = null;
    this.previewIsImage = false;
    this.previewFileName = null;
  }
  goToProfile(): void {
    if (this.companyId) {
      this.route.navigate(['company-previewprofile', this.companyId]);
    }
  }

  onSave(): void {
    if (!this.validateAll()) return;

    this.isSaving = true;
    this.saveError = null;
    this.saveSuccess = false;

    const [fromStr, toStr] = (this.profile.teamSize ?? '').split('–');
    const companySizeFrom = fromStr ? parseInt(fromStr.trim(), 10) : null;
    const companySizeTo = toStr ? parseInt(toStr.trim(), 10) : null;

    const requestPayload: any = {
      name: this.profile.fullName || null,
      email: this.profile.email || null,
      phoneNumber: this.profile.phone
        ? this.selectedCountry.dial + this.profile.phone
        : null,
      website: this.profile.website || null,
      aboutCompany: this.profile.about || null,
      benefits: this.profile.benefits || null,
      vision: this.profile.vision || null,
      companySizeFrom,
      companySizeTo,
      ownerName: this.profile.fullName || null,
      responsiblePersons: [],
      founder: this.profile.founder || null,
      foundedIn: this.profile.foundedIn || null,
      orgType: this.profile.orgType || null,
      industryType: this.profile.activityType || null,
      instagramLink: this.profile.instagram || null,
      linkedinLink: this.profile.linkedin || null,
      twitterLink: this.profile.twitter || null,
      facebookLink: this.profile.facebook || null,
      youtubeLink: this.profile.youtube || null,
      snapchatLink: this.profile.snapchat || null,
    };

    // ✅ FIX: tell the backend to clear the logo when the user removed it
    // and didn't upload a replacement. Adjust the field name to match your API.
    if (this.logoRemoved && !this.logoFile) {
      requestPayload.logoUrl = null;
      requestPayload.deleteLogo = true;
    }

    const formData = new FormData();
    formData.append(
      'request',
      new Blob([JSON.stringify(requestPayload)], { type: 'application/json' }),
    );
    if (this.logoFile) formData.append('logo', this.logoFile);
    if (this.coverFiles.length) formData.append('cover', this.coverFiles[0]);
    if (this.taxDocFile)
      formData.append('taxRegistrationDocument', this.taxDocFile);
    if (this.commercialDocFile)
      formData.append('commercialRegistrationDocument', this.commercialDocFile);

    this.companyProfileService.updateCompanyProfile(formData).subscribe({
      next: (res: any) => {
        this.isSaving = false;
        this.saveSuccess = true;
        this.logoFile = null;
        this.logoRemoved = false; // ✅ FIX: reset the flag after successful save
        this.coverFiles = [];
        this.taxDocFile = null;
        this.commercialDocFile = null;

        if (res?.logoUrl || res?.coverUrl) {
          if (res.logoUrl) this.logoPreview = res.logoUrl;
          if (res.coverUrl) this.coverPreviews = [res.coverUrl];
          this.snapshotOriginal();
        } else {
          this.companyProfileService.getCompanyProfile().subscribe({
            next: (fresh: any) => {
              if (fresh?.logoUrl) this.logoPreview = fresh.logoUrl;
              if (fresh?.coverUrl) this.coverPreviews = [fresh.coverUrl];
              this.snapshotOriginal();
            },
            error: () => {
              this.snapshotOriginal();
            },
          });
        }

        setTimeout(() => (this.saveSuccess = false), 3000);
      },
      error: (err) => {
        this.isSaving = false;
        this.saveError =
          err?.error?.message ?? 'Failed to save. Please try again.';
      },
    });
  }

  onCancel(): void {
    this.profile = { ...this.originalProfile };
    this.logoPreview = this.originalLogo;
    this.coverPreviews = [...this.originalCovers];
    this.logoFile = null;
    this.logoRemoved = false; // ✅ FIX: reset on cancel too
    this.coverFiles = [];

    this.taxDocFile = null;
    this.commercialDocFile = null;
    this.taxDocName = this.originalTaxDocName;
    this.commercialDocName = this.originalCommercialDocName;
    this.saveError = null;
    this.errors = {};
    this.touched = {};

    if (this.quillInstance) {
      this.quillInstance.root.innerHTML = this.profile.about ?? '';
    }
    if (this.quillBenefitsInstance) {
      this.quillBenefitsInstance.root.innerHTML = this.profile.benefits ?? '';
    }
    if (this.quillVisionInstance) {
      this.quillVisionInstance.root.innerHTML = this.profile.vision ?? '';
    }
  }

  private addCoverFiles(files: File[]): void {
    files.forEach((file) => {
      this.coverFiles.push(file);
      this.readFile(file, (result) => this.coverPreviews.push(result));
    });
  }

  private snapshotOriginal(): void {
    this.originalProfile = { ...this.profile };
    this.originalLogo = this.logoPreview;
    this.originalCovers = [...this.coverPreviews];
    this.originalTaxDocName = this.taxDocName;
    this.originalCommercialDocName = this.commercialDocName;
  }

  private readFile(file: File, callback: (result: string) => void): void {
    const reader = new FileReader();
    reader.onload = () => callback(reader.result as string);
    reader.readAsDataURL(file);
  }

  get filteredCountries() {
    const q = this.countrySearch.toLowerCase().trim();
    if (!q) return this.countries;
    return this.countries.filter(
      (c) =>
        c.name.toLowerCase().includes(q) ||
        c.dial.includes(q) ||
        c.code.includes(q),
    );
  }

  toggleCountryDropdown(): void {
    this.showCountryDropdown = !this.showCountryDropdown;
    if (this.showCountryDropdown) this.countrySearch = '';
  }

  selectCountry(country: any, event?: Event): void {
    if (event) event.stopPropagation();
    this.selectedCountry = country;
    this.showCountryDropdown = false;
    this.countrySearch = '';
  }

  @HostListener('document:click', ['$event'])
  onDocumentClick(event: MouseEvent): void {
    const trigger = this.countryTrigger?.nativeElement;
    if (trigger && !trigger.contains(event.target)) {
      this.showCountryDropdown = false;
    }
  }
}
